/**
 * Image uploads (covers, chapter art). The API streams the file to the
 * media bucket and returns a public URL to store in `coverUrl` / `imageUrl`.
 */
export const UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
export const UPLOAD_CONTENT_TYPES = ["image/png", "image/jpeg", "image/webp", "image/gif"];
//# sourceMappingURL=uploads.js.map